<div *ngIf="product" class="container mx-auto px-6 py-12 max-w-7xl font-serif">
  <div class="flex flex-col lg:flex-row gap-12">
    <!-- Left: Main Image + Thumbnails -->
    <div class="lg:w-1/2 flex gap-4">
      <!-- Desktop: Thumbnails -->
      <div class="hidden lg:flex flex-col gap-4 w-20">
        <div *ngFor="let image of product.detail?.galerie.data; let i = index"
             class="w-20 h-20 border rounded-md overflow-hidden hover:border-gold cursor-pointer"
             style="border-color: var(--lt-color-border-light);"
             [ngClass]="{'border-gold': i === activeImageIndex}"
             (click)="changeMainImage(image.img, i)">
          <img [src]="image.thumb" [alt]="image.caption" class="w-full h-full object-cover">
        </div>
      </div>

      <!-- Desktop: Main Image -->
      <div class="hidden lg:block flex-1 border rounded-2xl overflow-hidden shadow-sm relative"
           style="border-color: var(--lt-color-border-light); box-shadow: var(--lt-shadowDefault);">
        <img #productImage
             [src]="activeImageUrl || product.detail?.galerie.data[0]?.img || 'https://via.placeholder.com/500x600'"
             [alt]="product.name"
             class="w-full h-[500px] object-contain bg-white transition-transform duration-300 hover:brightness-110">
        <div class="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
      </div>

      <!-- Mobile: Image Slider -->
      <div class="lg:hidden w-full">
        <swiper [config]="swiperConfig" class="w-full h-[400px]">
          <ng-template swiperSlide *ngFor="let image of product.detail?.galerie.data">
            <div class="w-full h-full flex items-center justify-center bg-white">
              <img [src]="image.img" [alt]="image.caption" class="max-w-full max-h-full object-contain">
            </div>
          </ng-template>
          <!-- Pagination -->
          <div class="swiper-pagination"></div>
        </swiper>
      </div>
    </div>

    <!-- Right: Details & Pricing -->
    <div class="lg:w-1/2">
      <!-- Brand and Name -->
      <h2 class="text-sm uppercase tracking-widest font-semibold" style="color: var(--lt-color-text-light);">
        {{ product.marque }}
      </h2>
      <h1 class="text-4xl font-semibold text-gray-900 mt-2" style="color: var(--lt-color-text-dark);">
        {{ product.detail?.nomProduit || product.name }}
      </h1>
      <p class="text-gray-600 mt-4 italic" style="color: var(--lt-color-text-very-light);">
        {{ product.detail?.baseline || product.description }}
      </p>

      <!-- Short Description -->
      <p class="mt-4 text-gray-700" style="color: var(--lt-color-text-default);">
        {{ product.detail?.descriptionCourte }}
      </p>

      <!-- Pricing Table -->
      <div class="mt-6 border-t pt-4" style="border-color: var(--lt-color-border-default);">
        <div class="flex items-center justify-between">
          <span class="text-lg font-medium" style="color: var(--lt-color-text-default);">
            {{ product.detail?.baseline || '' }}
          </span>
          <!--<span *ngIf="selectedPriceIndex !== -1 && detailsPrix?.options[selectedPriceIndex]?.data?.special_price"
                class="text-red-600 font-semibold bg-red-100 px-3 py-1 rounded-full text-sm">
            PROMO
          </span>-->
        </div>
        <p *ngIf="selectedPriceIndex != -1 && selectedPrice else notYeySelectedPrice" class="text-xl font-bold text-red-700 mt-2">
          {{ ((selectedPrice + "" | rawPrice) || product.price) | currency:'MAD' }}
        </p>
        <ng-template #notYeySelectedPrice>
          <p class="text-xl font-bold text-red-700 mt-2">
            À partir de  {{ product.price  *13 | currency:'MAD' }}
          </p>
        </ng-template>

        <!-- Volume/Price Cards -->
        <div *ngIf="detailsPrix?.options" class="flex flex-wrap gap-3 mt-4">
          <div *ngFor="let item of detailsPrix?.options; let i = index"
               class="border rounded-lg px-3 py-2 text-center shadow hover:shadow-md transition-all cursor-pointer min-w-[100px]"
               style="border-color: var(--lt-color-border-light); box-shadow: var(--lt-shadowDefault);"
               [ngClass]="{'border-gold bg-gold': i === selectedPriceIndex}"
               (click)="selectPrice(item.data.special_price , i)">
            <div class="text-xs font-medium" style="color: var(--lt-color-text-very-light);">
              {{ item.data?.sku || 'REMXX' }}
            </div>
            <div class="text-base font-semibold mt-1" style="color: var(--lt-color-text-dark);">
              {{ item.label }}
            </div>
            <div *ngIf="item.data?.special_price" class="text-xs line-through mt-1" style="color: var(--lt-color-text-light);">
              {{ item.data?.price  | rawPrice | currency:'MAD'}}
            </div>
            <div class="text-lg font-bold text-red-700 mt-1">
              {{ (item.data?.special_price || item.data?.price) | rawPrice | currency:'MAD' }}
            </div>
            <span *ngIf="item.data?.special_price" class="text-xs mt-1 inline-block bg-red-500 text-white px-2 py-0.5 rounded-full">
              PROMO
            </span>
          </div>
        </div>

        <!-- Quantity Selection and Add to Cart Button -->
        <!-- Quantity Selection and Add to Cart Button -->
        <div class="flex items-center gap-4 mt-6 w-full">
          <!-- Quantity Control -->
          <div class="control flex items-center border rounded-lg p-2 h-12"
               style="border-color: var(--lt-color-border-default); background-color: var(--lt-color-background-light);">
            <button class="action minus w-8 h-8 flex items-center justify-center text-gold hover:bg-gray-100 transition-all duration-300 rounded-full"
                    type="button" title="Minus" (click)="decreaseQuantity()">
              <span class="text-xl">-</span>
            </button>
            <input type="number" name="qty" id="qty" min="1" [max]="maxQuantity" [(ngModel)]="selectedQuantity" (ngModelChange)="onQuantityChange()"
                   class="input-text qty w-16 h-8 text-center border-none focus:ring-0 text-base font-semibold text-gold bg-transparent"
                   data-validate="{'required-number':true,'validate-item-quantity':{'maxAllowed':6}}"
                   style="color: var(--lt-color-text-dark);">
            <button class="action plus w-8 h-8 flex items-center justify-center text-gold hover:bg-gray-100 transition-all duration-300 rounded-full"
                    type="button" title="Plus" (click)="increaseQuantity()">
              <span class="text-xl">+</span>
            </button>
          </div>

          <!-- Add to Cart Button -->
          <button (click)="onAddToCart()"
                  class="add-to-cart-btn flex-1 h-12 flex items-center justify-center transition-all duration-300 relative overflow-hidden bg-gradient-to-r from-gold to-yellow-600 hover:from-red-700 hover:to-red-600 text-white font-serif text-base sm:text-lg font-bold rounded-lg"
                  [class.pressed]="isAddingToCart"
                  [class.animate-bounce]="isAddingToCart">
            <!-- Desktop Text -->
            <span class="hidden sm:inline-flex items-center">
              <i class="fas fa-shopping-cart mr-2 text-lg"></i>
              <span class="button-text">Ajouter</span>
            </span>
            <!-- Mobile Icon Only -->
            <span class="sm:hidden flex items-center">
              <i class="fas fa-shopping-cart text-xl mr-2"></i>
              <span class="button-text">Ajouter</span>
            </span>
            <!-- Animation Elements -->
            <div class="cart-animation" *ngIf="isAddingToCart">
              <div class="cart-item" *ngFor="let item of animationItems">
                <div class="product-preview">
                  <img [src]="activeImageUrl || product.detail?.galerie.data[0]?.img" [alt]="product.name" class="w-8 h-8 object-cover rounded-full">
                </div>
                <div class="plus">+1</div>
              </div>
            </div>
          </button>
        </div>
      </div>


    </div>
  </div>
  <div class="mt-8">
    <!-- Horizontal Buttons -->
    <div class="flex space-x-4 border-b pb-2" style="border-color: var(--lt-color-border-default);">
      <button class="px-4 py-2 font-medium rounded-t-lg transition-colors duration-300"
              style="color: var(--lt-color-text-default);"
              [ngClass]="{'bg-gold text-white': selectedSection === 'description', 'hover:bg-gray-200': selectedSection !== 'description'}"
              (click)="selectSection('description')">
        Description
      </button>

      <button class="px-4 py-2 font-medium rounded-t-lg transition-colors duration-300"
              style="color: var(--lt-color-text-default);"
              [ngClass]="{'bg-gold text-white': selectedSection === 'olfactive', 'hover:bg-gray-200': selectedSection !== 'olfactive'}"
              (click)="selectSection('olfactive')">
        Notes Olfactives
      </button>
      <button class="px-4 py-2 font-medium rounded-t-lg transition-colors duration-300"
              style="color: var(--lt-color-text-default);"
              [ngClass]="{'bg-gold text-white': selectedSection === 'ingredients', 'hover:bg-gray-200': selectedSection !== 'ingredients'}"
              (click)="selectSection('ingredients')">
        Ingrédients
      </button>

      <!--
            <button class="px-4 py-2 font-medium rounded-t-lg transition-colors duration-300"
                    style="color: var(&#45;&#45;lt-color-text-default);"
                    [ngClass]="{'bg-gold text-white': selectedSection === 'availability', 'hover:bg-gray-200': selectedSection !== 'availability'}"
                    (click)="selectSection('availability')">
              Disponibilité
            </button>
      -->
   <!--   <button class="px-4 py-2 font-medium rounded-t-lg transition-colors duration-300"
              style="color: var(&#45;&#45;lt-color-text-default);"
              [ngClass]="{'bg-gold text-white': selectedSection === 'share', 'hover:bg-gray-200': selectedSection !== 'share'}"
              (click)="selectSection('share')">
        Partager
      </button>-->
    </div>

    <!-- Content Area -->
    <div class="mt-4 p-4 border rounded-lg" style="border-color: var(--lt-color-border-light); background-color: var(--lt-color-background-light);">
      <div *ngIf="selectedSection === 'olfactive'">
        <p class="text-sm" style="color: var(--lt-color-text-light); white-space: pre-line;">
          {{ product.detail?.notesOlfactives }}
        </p>
      </div>
      <div *ngIf="selectedSection === 'availability'">
        <p class="text-sm" style="color: var(--lt-color-text-light);">
          {{ product.detail?.disponibilite }}
        </p>
      </div>
      <div *ngIf="selectedSection === 'ingredients'">
        <p class="text-sm" style="color: var(--lt-color-text-light); white-space: pre-line;">
          {{ product.detail?.ingredients }}
        </p>
      </div>
      <div *ngIf="selectedSection === 'description'">
        <p class="text-sm" style="color: var(--lt-color-text-light); white-space: pre-line;">
          {{ product.detail?.descriptionLongue }}
        </p>
      </div>
      <div *ngIf="selectedSection === 'share'">
        <div class="flex gap-2">
          <a class="w-8 h-8 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gold transition-colors duration-300" href="#" title="Facebook">
            <i class="socicon-facebook text-sm"></i>
          </a>
          <a class="w-8 h-8 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gold transition-colors duration-300" href="#" title="Twitter">
            <i class="socicon-twitter text-sm"></i>
          </a>
          <a class="w-8 h-8 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gold transition-colors duration-300" href="#" title="Instagram">
            <i class="socicon-instagram text-sm"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
